import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-460020c1"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "root"
};
const _hoisted_2 = {
  class: "main-content flex-row"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex-row-center logo-container"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "logo"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "company-name"
}, "Waterboger")], -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex-full flex-col contact"
}, null, -1));
const _hoisted_5 = {
  class: "search flex-row"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex-row"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "phone-icon"
}), /*#__PURE__*/_createElementVNode("a", {
  href: "tel:13423676525"
}, "86-0755-27990959")], -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "search-icon"
}, null, -1));
const _hoisted_8 = {
  class: "nav-content"
};
const _hoisted_9 = {
  class: "nav flex-row"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RouterLink = _resolveComponent("RouterLink");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_RouterLink, {
    to: "/"
  }, {
    default: _withCtx(() => [_hoisted_3]),
    _: 1
  }), _hoisted_4, _createElementVNode("div", _hoisted_5, [_hoisted_6, _createVNode(_component_el_button, {
    link: "",
    onClick: _ctx.changeLanguage,
    class: "language"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.localeLanguage), 1)]),
    _: 1
  }, 8, ["onClick"]), _hoisted_7])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, i) => {
    return _openBlock(), _createElementBlock(_Fragment, {
      key: i
    }, [!item.enable ? (_openBlock(), _createBlock(_component_RouterLink, {
      key: 0,
      to: item.link ? item.link : '',
      class: "menu-link",
      onClick: $event => _ctx.navIndex = i
    }, {
      default: _withCtx(() => [_createElementVNode("div", {
        class: _normalizeClass(["menu", i == _ctx.navIndex ? 'select' : ''])
      }, _toDisplayString(_ctx.$t(item.title)), 3)]),
      _: 2
    }, 1032, ["to", "onClick"])) : _createCommentVNode("", true)], 64);
  }), 128))])])]);
}